import { useState } from 'react';
import ReactDOM from 'react-dom';

import lang from '../../../../lib/language';
import { formatCurrency } from '../../../../lib/util/DataHelpers';

import questionIcon from '../../../../assets/img/info-circle.png';
import { ClickableImage, MobileDrawer } from '../../../../components';
import { useIsMobile } from '../../../../hooks';

import CanvasHalfCircle from './CanvasHalfCircle';

import styles from './ProgressPie.module.scss';

type Props = {
  isLoading?: boolean;
  progress: number;
  maxValue: number;
  color: string;
  size?: number;
  thickness?: number;
  backgroundColor?: string;
};

export default function ProgressPie({
  progress,
  maxValue,
  color,
  isLoading,
  size = 218,
  thickness = 15,
  backgroundColor = '#3BB0FF33',
}: Props) {
  const { isMobile } = useIsMobile();
  const container = document.getElementById('scoreCalculatorPieChart');
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

  const showTooltip = () => {
    setIsTooltipVisible(true);
  };

  const hideTooltip = () => {
    setIsTooltipVisible(false);
  };

  const toggleTooltipOnTouch = () => {
    setIsTooltipVisible((prev) => !prev);
  };

  return (
    <>
      <div className={styles.chart}>
        <div className={styles.chartInfo}>
          <div className={styles.profitTargetTitle}>
            <div>{lang.profitLoss()}</div>
            <ClickableImage
              className={styles.infoIcon}
              src={questionIcon}
              alt="i"
              onClick={toggleTooltipOnTouch}
              onMouseEnter={() => {
                if (isMobile) return;
                showTooltip();
              }}
              onMouseLeave={() => {
                if (isMobile) return;
                hideTooltip();
              }}
            />
            {!isMobile && container && isTooltipVisible && ReactDOM.createPortal(
              <div
                className={styles.tooltipWrapper}
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}
              >
                <div className={styles.tooltip}>{lang.profitTargetToolTipText()}</div>
              </div>, container,
            )}
          </div>
          <div className={styles.currentProgress}>{formatCurrency(isLoading ? 0 : progress)}</div>
          <div className={styles.maxProgress}>{`${lang.target()}: ${formatCurrency(isLoading ? 0 : maxValue)}`}</div>
        </div>

        {isMobile && (
          <MobileDrawer isOpen={isTooltipVisible} title={lang.profitTarget()} onClose={hideTooltip}>
            <div className={styles.drawerText}>{lang.profitTargetToolTipText()}</div>
          </MobileDrawer>
        )}

        <CanvasHalfCircle
          progress={progress}
          maxValue={maxValue}
          color={color}
          isLoading={isLoading}
          size={size}
          thickness={thickness}
          backgroundColor={backgroundColor}
        />
      </div>
    </>
  );
}
